import React, { useEffect, useState, useRef } from 'react';
import { MenuIcon, X, ChevronDown, Phone } from 'lucide-react';
import { MegaMenu } from './MegaMenu';
import { DropdownNav } from './DropdownNav';
import { Link } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const headerRef = useRef(null);
  const topBarHeight = useRef(0);
  const instagramUrl = 'https://www.instagram.com/veranova_klussen?igsh=MTY5MmppcGx2ZmN2OQ==';
  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
      setIsScrolled(position > 10);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="absolute top-0 left-0 right-0 z-50" data-id="element-551">
      {/* Top bar - static */}
      <div className="bg-gray-900 text-white py-2 w-full relative" data-id="element-552">
        <div className="container mx-auto px-6" data-id="element-553">
          <div className="flex justify-between items-center" data-id="element-554">
            {/* Top bar with contact info */}
            <div className="hidden md:flex items-center space-x-6" data-id="element-555">
              <a href="tel:+31625023378" className="text-white/80 hover:text-white text-sm flex items-center gap-1.5 transition-colors" data-id="element-556">
                <Phone size={14} className="text-[#CDA735]" data-id="element-557" />
                <span data-id="element-558">+31 (0)6 250 233 78</span>
              </a>
              <span className="text-white/50 text-sm" data-id="element-559">|</span>
              <a href="mailto:info@veranovaklussen.nl" className="text-white/80 hover:text-white text-sm transition-colors" data-id="element-560">
                info@veranovaklussen.nl
              </a>
            </div>
            {/* Top bar content */}
            <div className="flex items-center space-x-4 ml-auto" data-id="element-561">
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-white text-sm transition-colors border-b border-[#CDA735]/40 hover:border-[#CDA735] pb-0.5" data-id="element-562">
                Inspiratie & voorbeelden
              </a>
              <span className="text-white/50 text-sm" data-id="element-563">|</span>
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-white text-sm transition-colors border-b border-[#CDA735]/40 hover:border-[#CDA735] pb-0.5" data-id="element-564">
                Recente projecten
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Main header - becomes fixed on scroll */}
      <header className={`w-full transition-all duration-300 ${isScrolled ? 'fixed top-0 left-0 right-0 bg-gray-900/95 backdrop-blur-md shadow-[0_4px_30px_rgba(0,0,0,0.2)]' : 'bg-gradient-to-b from-black/80 via-black/50 to-transparent backdrop-blur-sm'}`} data-id="element-565">
        <div className="container mx-auto px-6" data-id="element-566">
          <div className="flex items-end justify-between py-2" data-id="element-567">
            {/* Main header logo */}
            <Link to="/" data-id="element-568">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j38SAssrtskzGcKewqUYrE/Veranova_Logo.png" alt="Veranova" className={`transition-all duration-300 ${isScrolled ? 'h-12 md:h-14 brightness-125' : 'h-14 md:h-18 brightness-110'}`} data-id="element-569" />
            </Link>
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-end" data-id="element-570">
              <div className="flex items-center" data-id="element-571">
                <Link to="/producten" className={`mx-6 font-medium transition-all text-white hover:text-[#CDA735] opacity-90 hover:opacity-100`} data-id="element-572">
                  Producten
                </Link>
                <Link to="/over-ons" className={`mx-6 font-medium transition-all text-white hover:text-[#CDA735] opacity-90 hover:opacity-100`} data-id="element-573">
                  Over ons
                </Link>
                <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className={`mx-6 font-medium transition-all text-white hover:text-[#CDA735] opacity-90 hover:opacity-100`} data-id="element-574">
                  Inspiratie
                </a>
                <Link to="/contact" className={`mx-6 font-medium transition-all text-white hover:text-[#CDA735] opacity-90 hover:opacity-100`} data-id="element-575">
                  Contact
                </Link>
              </div>
            </nav>
            {/* CTA Buttons */}
            <div className="hidden md:flex items-center gap-4" data-id="element-576">
              <div className="flex gap-3" data-id="element-577">
                <Link to="/adviesgesprek" className="transition-all font-medium text-sm shadow-sm flex items-center bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-4 py-2.5 rounded-md" data-id="element-578">
                  <span data-id="element-579">Plan een adviesgesprek</span>
                </Link>
                <Link to="/offerte-aanvragen" className="transition-all font-medium text-sm shadow-md flex items-center bg-[#CDA735] hover:bg-[#B89429] text-white px-6 py-2.5 rounded-md hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]" data-id="element-580">
                  <span data-id="element-581">Offerte aanvragen</span>
                  <span className="ml-2 bg-white/20 rounded-full p-0.5" data-id="element-582">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-583">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-584" />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
            {/* Mobile Menu Button */}
            <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-585">
              {isMenuOpen ? <X size={24} data-id="element-586" /> : <MenuIcon size={24} data-id="element-587" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden bg-gray-900/95 backdrop-blur-md shadow-lg max-h-[80vh] overflow-y-auto" data-id="element-588">
            <div className="container mx-auto px-6 py-6 flex flex-col space-y-5" data-id="element-589">
              <div className="space-y-5" data-id="element-590">
                <Link to="/producten" className="block text-white hover:text-[#CDA735] font-medium transition-colors py-1" data-id="element-591">
                  Producten
                </Link>
                <Link to="/over-ons" className="block text-white hover:text-[#CDA735] font-medium transition-colors py-1" data-id="element-592">
                  Over ons
                </Link>
                <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="block text-white hover:text-[#CDA735] font-medium transition-colors py-1" data-id="element-593">
                  Inspiratie
                </a>
                <Link to="/contact" className="block text-white hover:text-[#CDA735] font-medium transition-colors py-1" data-id="element-594">
                  Contact
                </Link>
              </div>
              <div className="pt-4 border-t border-gray-800 space-y-4" data-id="element-595">
                <a href="tel:+31625023378" className="flex items-center text-white/80 hover:text-white" data-id="element-596">
                  <Phone size={16} className="text-[#CDA735] mr-2" data-id="element-597" />
                  +31 (0)6 250 233 78
                </a>
                <div className="flex flex-col space-y-3" data-id="element-598">
                  <Link to="/adviesgesprek" className="bg-white/10 backdrop-blur-sm text-white px-5 py-3 rounded-md hover:bg-white/15 transition-colors font-medium text-center flex items-center justify-center" data-id="element-599">
                    <span data-id="element-600">Plan een adviesgesprek</span>
                  </Link>
                  <Link to="/offerte-aanvragen" className="bg-[#CDA735] text-white px-5 py-3 rounded-md hover:bg-[#B89429] transition-colors font-medium text-center shadow-md flex items-center justify-center" data-id="element-601">
                    <span data-id="element-602">Offerte opvragen</span>
                    <span className="ml-2 bg-white/20 rounded-full p-0.5" data-id="element-603">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-604">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-605" />
                      </svg>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>}
      </header>
    </div>;
};